import { useMutation } from 'react-query';
import { createRegisterResult } from 'apis/registerResult';

const useMutationCreateRegisterResult = () => {
  const { mutateAsync, ...rest } = useMutation(createRegisterResult);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationCreateRegisterResult;
